<template>
  <NuxtLink v-bind="linkProps" :to="contextPath" :target="contextTargetAttr">
    <slot />
  </NuxtLink>
</template>

<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router';

  import type { NuxtLinkProps } from '#app';

  /**
   * 客製化的 NuxtLink
   * 判斷網址是否為外部連結，並自動設定 target 屬性
   */

  interface IProps extends NuxtLinkProps {
    to: RouteLocationRaw;
    title?: string;
  }

  const props = defineProps<IProps>();

  const linkProps = computed((): NuxtLinkProps => {
    const { to, target, ...nuxtLinkProps } = props;
    return { ...nuxtLinkProps };
  });

  const isLink = computed((): boolean => props.to !== undefined);

  const contextPath = computed((): RouteLocationRaw => {
    // 將 query string 中的 + 號轉換為 %2B、空格轉換為 +
    if (typeof props.to === 'string') {
      const questionMarkIndex = props.to.indexOf('?');
      if (questionMarkIndex === -1) {
        return props.to;
      }
      const path = props.to.slice(0, questionMarkIndex);
      const query = props.to
        .slice(questionMarkIndex)
        .replace(/\+/g, '%2B')
        .replace(/ /g, '+');
      return `${path}${query}`;
    }
    return props.to;
  });

  const contextTargetAttr = computed((): string | undefined => {
    if (isLink.value && !props.target) {
      if (typeof props.to === 'string' && props.to.indexOf('http') === 0) {
        return '_blank';
      }
      return '_self';
    }

    if (isLink.value && props.target) {
      return props.target;
    }

    return undefined;
  });
</script>
